import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["selectable", "isSelected", "isHighlighted", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { alpha } from 'utils/ui';
import { borderValue } from 'styles/mixins';
import TabIndexContext from 'components/TabIndexContext';
import { withTableContext, tableContextPropFilter } from './TableContext';
import { getBreakpoint } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
var Tr = withTableContext(styled.tr.withConfig({
  shouldForwardProp: tableContextPropFilter
}).withConfig({
  displayName: "TableRow__Tr",
  componentId: "sc-x48l91-0"
})(["vertical-align:", ";tbody &:not([aria-selected]):hover{background-color:", ";}tbody &:not([aria-selected]):focus-within{background-color:", ";}&[aria-selected]{cursor:pointer;}tbody:hover &[data-highlighted]{outline:1px solid ", ";outline-offset:-1px;background-color:", ";}tbody &[data-highlighted]:focus-within{outline:1px solid ", ";outline-offset:-1px;background-color:", ";}tbody &[aria-selected='true'],tbody &[aria-selected='true'][data-highlighted]{background-color:", ";}@media (max-width:", "){position:relative;display:flex;flex-direction:column;padding-bottom:", ";border-bottom:", ";}"], function (p) {
  return p.align || 'inherit';
}, function (p) {
  return alpha(p.theme.shade, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return alpha(p.theme.shade, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return p.theme.links;
}, function (p) {
  return alpha(p.theme.links, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return p.theme.links;
}, function (p) {
  return alpha(p.theme.links, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return alpha(p.theme.links, Math.max(0.15, +p.theme.shadeStrength));
}, getBreakpoint('mobileViewBreakpoint'), function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return borderValue(p.theme);
}));
var TableRow = function TableRow(_ref) {
  var selectable = _ref.selectable,
    isSelected = _ref.isSelected,
    isHighlighted = _ref.isHighlighted,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(TabIndexContext, {
    disabled: Boolean(selectable && !isHighlighted),
    children: /*#__PURE__*/_jsx(Tr, _objectSpread(_objectSpread({}, otherProps), {}, {
      "aria-selected": selectable ? isSelected : undefined,
      "data-highlighted": selectable && isHighlighted || null,
      children: children
    }))
  });
};
TableRow.displayName = 'TableRow';
export default TableRow;